{
  "id": "the-hex",
  "name": "Hexcore",
  "specialRules": [
    "All players are randomly assigned an outer home base hex they begin on, spread as evenly around the ring as the count allows.",
    "Each home base is worth +3 troops.",
    "The middle hex (the Core) defends with 4-sided dice and is worth a +8 troop bonus."
  ],
  "viewBox": {
    "x": 27.96,
    "y": 56.8,
    "width": 1044.08,
    "height": 686.4
  },
  "backdropColor": {
    "light": "#dfe3e1",
    "dark": "#262c2e",
    "topBar": true
  },
  "borderChevrons": {
    "territoryIds": [
      "hex-core"
    ]
  },
  "legend": {
    "position": "bottom-right",
    "centerY": 560,
    "items": [
      {
        "symbol": "chevron",
        "kind": "advantage",
        "label": "6 v 4"
      }
    ]
  },
  "forceSeaRouteTuning": {
    "hex-east-4|hex-home-east-2": {
      "endpointMode": "edge-midpoints"
    },
    "hex-home-east-1|hex-northeast-4": {
      "endpointMode": "edge-midpoints"
    },
    "hex-home-east-3|hex-southeast-4": {
      "endpointMode": "edge-midpoints"
    },
    "hex-home-west-1|hex-northwest-4": {
      "endpointMode": "edge-midpoints"
    },
    "hex-home-west-2|hex-west-4": {
      "endpointMode": "edge-midpoints"
    },
    "hex-home-west-3|hex-southwest-4": {
      "endpointMode": "edge-midpoints"
    }
  },
  "edgeConfig": {
    "internalBorderWidth": 3,
    "regionBorderWidth": 11.6,
    "bridgeStrokeWidth": 0
  },
  "fixedSetup": {
    "playerCount": 6,
    "minPlayers": 2,
    "areas": [
      {
        "id": "hex-home-west-1",
        "armies": {
          "hex-home-west-1": 7
        }
      },
      {
        "id": "hex-home-east-1",
        "armies": {
          "hex-home-east-1": 7
        }
      },
      {
        "id": "hex-home-east-2",
        "armies": {
          "hex-home-east-2": 7
        }
      },
      {
        "id": "hex-home-east-3",
        "armies": {
          "hex-home-east-3": 7
        }
      },
      {
        "id": "hex-home-west-3",
        "armies": {
          "hex-home-west-3": 7
        }
      },
      {
        "id": "hex-home-west-2",
        "armies": {
          "hex-home-west-2": 7
        }
      }
    ],
    "seating": "ring",
    "neutralArmies": 3,
    "neutralOverrides": {
      "hex-core": 10,
      "hex-home-west-1": 7,
      "hex-home-west-2": 7,
      "hex-home-west-3": 7,
      "hex-home-east-1": 7,
      "hex-home-east-2": 7,
      "hex-home-east-3": 7
    }
  },
  "forceSeaRoutes": [
    [
      "hex-home-west-1",
      "hex-northwest-4"
    ],
    [
      "hex-home-west-2",
      "hex-west-4"
    ],
    [
      "hex-home-west-3",
      "hex-southwest-4"
    ],
    [
      "hex-home-east-1",
      "hex-northeast-4"
    ],
    [
      "hex-home-east-2",
      "hex-east-4"
    ],
    [
      "hex-home-east-3",
      "hex-southeast-4"
    ]
  ],
  "regions": [
    {
      "id": "east",
      "name": "East Reach",
      "bonus": 4,
      "territoryIds": [
        "hex-east-1",
        "hex-east-2",
        "hex-east-3",
        "hex-east-4",
        "hex-east-5",
        "hex-east-6"
      ],
      "shape": "M 705.885 430 L 653.923 460 L 601.962 430 L 601.962 370 L 653.923 340 L 653.923 280 L 705.885 250 L 705.885 190 L 757.846 160 L 809.808 190 L 809.808 250 L 861.769 280 L 861.769 340 L 913.731 370 L 913.731 430 L 861.769 460 L 809.808 430 L 757.846 460 Z",
      "color": "#B8F000"
    },
    {
      "id": "northeast",
      "name": "Northeast Reach",
      "bonus": 4,
      "territoryIds": [
        "hex-northeast-1",
        "hex-northeast-2",
        "hex-northeast-3",
        "hex-northeast-4",
        "hex-northeast-5",
        "hex-northeast-6"
      ],
      "shape": "M 653.923 280 L 653.923 340 L 601.962 370 L 550 340 L 550 280 L 498.038 250 L 498.038 190 L 446.077 160 L 446.077 100 L 498.038 70 L 550 100 L 601.962 70 L 653.923 100 L 705.885 70 L 757.846 100 L 757.846 160 L 705.885 190 L 705.885 250 Z",
      "color": "#00D4E8"
    },
    {
      "id": "northwest",
      "name": "Northwest Reach",
      "bonus": 4,
      "territoryIds": [
        "hex-northwest-1",
        "hex-northwest-2",
        "hex-northwest-3",
        "hex-northwest-4",
        "hex-northwest-5",
        "hex-northwest-6"
      ],
      "shape": "M 498.038 250 L 550 280 L 550 340 L 498.038 370 L 446.077 340 L 394.115 370 L 342.154 340 L 290.192 370 L 238.231 340 L 238.231 280 L 290.192 250 L 290.192 190 L 342.154 160 L 342.154 100 L 394.115 70 L 446.077 100 L 446.077 160 L 498.038 190 Z",
      "color": "#4A148C"
    },
    {
      "id": "west",
      "name": "West Reach",
      "bonus": 4,
      "territoryIds": [
        "hex-west-1",
        "hex-west-2",
        "hex-west-3",
        "hex-west-4",
        "hex-west-5",
        "hex-west-6"
      ],
      "shape": "M 446.077 340 L 498.038 370 L 498.038 430 L 446.077 460 L 446.077 520 L 394.115 550 L 394.115 610 L 342.154 640 L 290.192 610 L 290.192 550 L 238.231 520 L 238.231 460 L 186.269 430 L 186.269 370 L 238.231 340 L 290.192 370 L 342.154 340 L 394.115 370 Z",
      "color": "#F5F5DC"
    },
    {
      "id": "southwest",
      "name": "Southwest Reach",
      "bonus": 4,
      "territoryIds": [
        "hex-southwest-1",
        "hex-southwest-2",
        "hex-southwest-3",
        "hex-southwest-4",
        "hex-southwest-5",
        "hex-southwest-6"
      ],
      "shape": "M 498.038 430 L 550 460 L 550 520 L 601.962 550 L 601.962 610 L 653.923 640 L 653.923 700 L 601.962 730 L 550 700 L 498.038 730 L 446.077 700 L 394.115 730 L 342.154 700 L 342.154 640 L 394.115 610 L 394.115 550 L 446.077 520 L 446.077 460 Z",
      "color": "#F48FB1"
    },
    {
      "id": "southeast",
      "name": "Southeast Reach",
      "bonus": 4,
      "territoryIds": [
        "hex-southeast-1",
        "hex-southeast-2",
        "hex-southeast-3",
        "hex-southeast-4",
        "hex-southeast-5",
        "hex-southeast-6"
      ],
      "shape": "M 601.962 430 L 653.923 460 L 705.885 430 L 757.846 460 L 809.808 430 L 861.769 460 L 861.769 520 L 809.808 550 L 809.808 610 L 757.846 640 L 757.846 700 L 705.885 730 L 653.923 700 L 653.923 640 L 601.962 610 L 601.962 550 L 550 520 L 550 460 Z",
      "color": "#00A038"
    },
    {
      "id": "core",
      "name": "The Core",
      "bonus": 8,
      "territoryIds": [
        "hex-core"
      ],
      "shape": "M 550 340 L 601.962 370 L 601.962 430 L 550 460 L 498.038 430 L 498.038 370 Z",
      "color": "#7A0000"
    },
    {
      "id": "home-west-1",
      "name": "Bunker Home",
      "bonus": 3,
      "territoryIds": [
        "hex-home-west-1"
      ],
      "shape": "M 255.884 70 L 307.846 100 L 307.846 160 L 255.884 190 L 203.922 160 L 203.922 100 Z",
      "color": "#F97316"
    },
    {
      "id": "home-west-2",
      "name": "Outpost Home",
      "bonus": 3,
      "territoryIds": [
        "hex-home-west-2"
      ],
      "shape": "M 100 340 L 151.962 370 L 151.962 430 L 100 460 L 48.038 430 L 48.038 370 Z",
      "color": "#EAB308"
    },
    {
      "id": "home-west-3",
      "name": "Aegis Home",
      "bonus": 3,
      "territoryIds": [
        "hex-home-west-3"
      ],
      "shape": "M 255.884 610 L 307.846 640 L 307.846 700 L 255.884 730 L 203.922 700 L 203.922 640 Z",
      "color": "#14B8A6"
    },
    {
      "id": "home-east-1",
      "name": "Fortress Home",
      "bonus": 3,
      "territoryIds": [
        "hex-home-east-1"
      ],
      "shape": "M 844.116 70 L 896.078 100 L 896.078 160 L 844.116 190 L 792.154 160 L 792.154 100 Z",
      "color": "#3B82F6"
    },
    {
      "id": "home-east-2",
      "name": "Anvil Home",
      "bonus": 3,
      "territoryIds": [
        "hex-home-east-2"
      ],
      "shape": "M 1000 340 L 1051.962 370 L 1051.962 430 L 1000 460 L 948.038 430 L 948.038 370 Z",
      "color": "#A855F7"
    },
    {
      "id": "home-east-3",
      "name": "Bulwark Home",
      "bonus": 3,
      "territoryIds": [
        "hex-home-east-3"
      ],
      "shape": "M 844.116 610 L 896.078 640 L 896.078 700 L 844.116 730 L 792.154 700 L 792.154 640 Z",
      "color": "#F43F5E"
    }
  ],
  "territories": [
    {
      "id": "hex-core",
      "name": "The Core",
      "regionId": "core",
      "adjacencies": [
        "hex-east-1",
        "hex-northeast-1",
        "hex-northwest-1",
        "hex-west-1",
        "hex-southwest-1",
        "hex-southeast-1"
      ],
      "borderDice": {
        "hex-east-1": {
          "defend": 4
        },
        "hex-northeast-1": {
          "defend": 4
        },
        "hex-northwest-1": {
          "defend": 4
        },
        "hex-west-1": {
          "defend": 4
        },
        "hex-southwest-1": {
          "defend": 4
        },
        "hex-southeast-1": {
          "defend": 4
        }
      },
      "shape": "M 550 340 L 601.962 370 L 601.962 430 L 550 460 L 498.038 430 L 498.038 370 Z",
      "position": {
        "x": 550,
        "y": 400
      },
      "badgeAnchor": {
        "x": 548.38,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-east-1",
      "name": "Rampart",
      "regionId": "east",
      "adjacencies": [
        "hex-east-2",
        "hex-east-3",
        "hex-northeast-1",
        "hex-core",
        "hex-southeast-1",
        "hex-southeast-3"
      ],
      "shape": "M 653.923 340 L 705.885 370 L 705.885 430 L 653.923 460 L 601.962 430 L 601.962 370 Z",
      "position": {
        "x": 653.923,
        "y": 400
      },
      "badgeAnchor": {
        "x": 652.3,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-east-2",
      "name": "Spearhead",
      "regionId": "east",
      "adjacencies": [
        "hex-east-4",
        "hex-east-5",
        "hex-east-3",
        "hex-east-1",
        "hex-southeast-3",
        "hex-southeast-6"
      ],
      "shape": "M 757.846 340 L 809.808 370 L 809.808 430 L 757.846 460 L 705.885 430 L 705.885 370 Z",
      "position": {
        "x": 757.846,
        "y": 400
      },
      "badgeAnchor": {
        "x": 756.22,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-east-3",
      "name": "Arsenal",
      "regionId": "east",
      "adjacencies": [
        "hex-east-5",
        "hex-east-6",
        "hex-northeast-2",
        "hex-northeast-1",
        "hex-east-1",
        "hex-east-2"
      ],
      "shape": "M 705.885 250 L 757.846 280 L 757.846 340 L 705.885 370 L 653.923 340 L 653.923 280 Z",
      "position": {
        "x": 705.885,
        "y": 310
      },
      "badgeAnchor": {
        "x": 707.51,
        "y": 308.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-east-4",
      "name": "Redoubt",
      "regionId": "east",
      "adjacencies": [
        "hex-east-5",
        "hex-east-2",
        "hex-southeast-6",
        "hex-home-east-2"
      ],
      "shape": "M 861.769 340 L 913.731 370 L 913.731 430 L 861.769 460 L 809.808 430 L 809.808 370 Z",
      "position": {
        "x": 861.769,
        "y": 400
      },
      "badgeAnchor": {
        "x": 860.15,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-east-5",
      "name": "Citadel",
      "regionId": "east",
      "adjacencies": [
        "hex-east-6",
        "hex-east-3",
        "hex-east-2",
        "hex-east-4"
      ],
      "shape": "M 809.808 250 L 861.769 280 L 861.769 340 L 809.808 370 L 757.846 340 L 757.846 280 Z",
      "position": {
        "x": 809.808,
        "y": 310
      },
      "badgeAnchor": {
        "x": 811.43,
        "y": 308.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-east-6",
      "name": "Stronghold",
      "regionId": "east",
      "adjacencies": [
        "hex-northeast-4",
        "hex-northeast-2",
        "hex-east-3",
        "hex-east-5"
      ],
      "shape": "M 757.846 160 L 809.808 190 L 809.808 250 L 757.846 280 L 705.885 250 L 705.885 190 Z",
      "position": {
        "x": 757.846,
        "y": 220
      },
      "badgeAnchor": {
        "x": 756.22,
        "y": 218.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northeast-1",
      "name": "Vanguard",
      "regionId": "northeast",
      "adjacencies": [
        "hex-east-3",
        "hex-northeast-2",
        "hex-northeast-3",
        "hex-northwest-1",
        "hex-core",
        "hex-east-1"
      ],
      "shape": "M 601.962 250 L 653.923 280 L 653.923 340 L 601.962 370 L 550 340 L 550 280 Z",
      "position": {
        "x": 601.962,
        "y": 310
      },
      "badgeAnchor": {
        "x": 603.59,
        "y": 308.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northeast-2",
      "name": "Legion",
      "regionId": "northeast",
      "adjacencies": [
        "hex-east-6",
        "hex-northeast-4",
        "hex-northeast-5",
        "hex-northeast-3",
        "hex-northeast-1",
        "hex-east-3"
      ],
      "shape": "M 653.923 160 L 705.885 190 L 705.885 250 L 653.923 280 L 601.962 250 L 601.962 190 Z",
      "position": {
        "x": 653.923,
        "y": 220
      },
      "badgeAnchor": {
        "x": 652.3,
        "y": 218.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northeast-3",
      "name": "Phalanx",
      "regionId": "northeast",
      "adjacencies": [
        "hex-northeast-2",
        "hex-northeast-5",
        "hex-northeast-6",
        "hex-northwest-2",
        "hex-northwest-1",
        "hex-northeast-1"
      ],
      "shape": "M 550 160 L 601.962 190 L 601.962 250 L 550 280 L 498.038 250 L 498.038 190 Z",
      "position": {
        "x": 550,
        "y": 220
      },
      "badgeAnchor": {
        "x": 548.38,
        "y": 218.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northeast-4",
      "name": "Cohort",
      "regionId": "northeast",
      "adjacencies": [
        "hex-northeast-5",
        "hex-northeast-2",
        "hex-east-6",
        "hex-home-east-1"
      ],
      "shape": "M 705.885 70 L 757.846 100 L 757.846 160 L 705.885 190 L 653.923 160 L 653.923 100 Z",
      "position": {
        "x": 705.885,
        "y": 130
      },
      "badgeAnchor": {
        "x": 707.51,
        "y": 128.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northeast-5",
      "name": "Banner",
      "regionId": "northeast",
      "adjacencies": [
        "hex-northeast-4",
        "hex-northeast-6",
        "hex-northeast-3",
        "hex-northeast-2"
      ],
      "shape": "M 601.962 70 L 653.923 100 L 653.923 160 L 601.962 190 L 550 160 L 550 100 Z",
      "position": {
        "x": 601.962,
        "y": 130
      },
      "badgeAnchor": {
        "x": 603.59,
        "y": 128.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northeast-6",
      "name": "Standard",
      "regionId": "northeast",
      "adjacencies": [
        "hex-northeast-5",
        "hex-northwest-4",
        "hex-northwest-2",
        "hex-northeast-3"
      ],
      "shape": "M 498.038 70 L 550 100 L 550 160 L 498.038 190 L 446.077 160 L 446.077 100 Z",
      "position": {
        "x": 498.038,
        "y": 130
      },
      "badgeAnchor": {
        "x": 496.41,
        "y": 128.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northwest-1",
      "name": "Trench",
      "regionId": "northwest",
      "adjacencies": [
        "hex-northeast-1",
        "hex-northeast-3",
        "hex-northwest-2",
        "hex-northwest-3",
        "hex-west-1",
        "hex-core"
      ],
      "shape": "M 498.038 250 L 550 280 L 550 340 L 498.038 370 L 446.077 340 L 446.077 280 Z",
      "position": {
        "x": 498.038,
        "y": 310
      },
      "badgeAnchor": {
        "x": 496.41,
        "y": 308.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northwest-2",
      "name": "Picket",
      "regionId": "northwest",
      "adjacencies": [
        "hex-northeast-3",
        "hex-northeast-6",
        "hex-northwest-4",
        "hex-northwest-5",
        "hex-northwest-3",
        "hex-northwest-1"
      ],
      "shape": "M 446.077 160 L 498.038 190 L 498.038 250 L 446.077 280 L 394.115 250 L 394.115 190 Z",
      "position": {
        "x": 446.077,
        "y": 220
      },
      "badgeAnchor": {
        "x": 447.7,
        "y": 218.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northwest-3",
      "name": "Salvo",
      "regionId": "northwest",
      "adjacencies": [
        "hex-northwest-1",
        "hex-northwest-2",
        "hex-northwest-5",
        "hex-northwest-6",
        "hex-west-2",
        "hex-west-1"
      ],
      "shape": "M 394.115 250 L 446.077 280 L 446.077 340 L 394.115 370 L 342.154 340 L 342.154 280 Z",
      "position": {
        "x": 394.115,
        "y": 310
      },
      "badgeAnchor": {
        "x": 392.49,
        "y": 308.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northwest-4",
      "name": "Volley",
      "regionId": "northwest",
      "adjacencies": [
        "hex-northeast-6",
        "hex-northwest-5",
        "hex-northwest-2",
        "hex-home-west-1"
      ],
      "shape": "M 394.115 70 L 446.077 100 L 446.077 160 L 394.115 190 L 342.154 160 L 342.154 100 Z",
      "position": {
        "x": 394.115,
        "y": 130
      },
      "badgeAnchor": {
        "x": 392.49,
        "y": 128.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northwest-5",
      "name": "Barrage",
      "regionId": "northwest",
      "adjacencies": [
        "hex-northwest-2",
        "hex-northwest-4",
        "hex-northwest-6",
        "hex-northwest-3"
      ],
      "shape": "M 342.154 160 L 394.115 190 L 394.115 250 L 342.154 280 L 290.192 250 L 290.192 190 Z",
      "position": {
        "x": 342.154,
        "y": 220
      },
      "badgeAnchor": {
        "x": 343.78,
        "y": 218.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-northwest-6",
      "name": "Fusilier",
      "regionId": "northwest",
      "adjacencies": [
        "hex-northwest-3",
        "hex-northwest-5",
        "hex-west-4",
        "hex-west-2"
      ],
      "shape": "M 290.192 250 L 342.154 280 L 342.154 340 L 290.192 370 L 238.231 340 L 238.231 280 Z",
      "position": {
        "x": 290.192,
        "y": 310
      },
      "badgeAnchor": {
        "x": 288.57,
        "y": 308.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-west-1",
      "name": "Cannon",
      "regionId": "west",
      "adjacencies": [
        "hex-core",
        "hex-northwest-1",
        "hex-northwest-3",
        "hex-west-2",
        "hex-west-3",
        "hex-southwest-1"
      ],
      "shape": "M 446.077 340 L 498.038 370 L 498.038 430 L 446.077 460 L 394.115 430 L 394.115 370 Z",
      "position": {
        "x": 446.077,
        "y": 400
      },
      "badgeAnchor": {
        "x": 447.7,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-west-2",
      "name": "Mortar",
      "regionId": "west",
      "adjacencies": [
        "hex-west-1",
        "hex-northwest-3",
        "hex-northwest-6",
        "hex-west-4",
        "hex-west-5",
        "hex-west-3"
      ],
      "shape": "M 342.154 340 L 394.115 370 L 394.115 430 L 342.154 460 L 290.192 430 L 290.192 370 Z",
      "position": {
        "x": 342.154,
        "y": 400
      },
      "badgeAnchor": {
        "x": 343.78,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-west-3",
      "name": "Howitzer",
      "regionId": "west",
      "adjacencies": [
        "hex-southwest-1",
        "hex-west-1",
        "hex-west-2",
        "hex-west-5",
        "hex-west-6",
        "hex-southwest-2"
      ],
      "shape": "M 394.115 430 L 446.077 460 L 446.077 520 L 394.115 550 L 342.154 520 L 342.154 460 Z",
      "position": {
        "x": 394.115,
        "y": 490
      },
      "badgeAnchor": {
        "x": 392.49,
        "y": 488.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-west-4",
      "name": "Musket",
      "regionId": "west",
      "adjacencies": [
        "hex-west-2",
        "hex-northwest-6",
        "hex-west-5",
        "hex-home-west-2"
      ],
      "shape": "M 238.231 340 L 290.192 370 L 290.192 430 L 238.231 460 L 186.269 430 L 186.269 370 Z",
      "position": {
        "x": 238.231,
        "y": 400
      },
      "badgeAnchor": {
        "x": 239.85,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-west-5",
      "name": "Sabre",
      "regionId": "west",
      "adjacencies": [
        "hex-west-3",
        "hex-west-2",
        "hex-west-4",
        "hex-west-6"
      ],
      "shape": "M 290.192 430 L 342.154 460 L 342.154 520 L 290.192 550 L 238.231 520 L 238.231 460 Z",
      "position": {
        "x": 290.192,
        "y": 490
      },
      "badgeAnchor": {
        "x": 288.57,
        "y": 488.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-west-6",
      "name": "Bayonet",
      "regionId": "west",
      "adjacencies": [
        "hex-southwest-2",
        "hex-west-3",
        "hex-west-5",
        "hex-southwest-4"
      ],
      "shape": "M 342.154 520 L 394.115 550 L 394.115 610 L 342.154 640 L 290.192 610 L 290.192 550 Z",
      "position": {
        "x": 342.154,
        "y": 580
      },
      "badgeAnchor": {
        "x": 343.78,
        "y": 578.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southwest-1",
      "name": "Raider",
      "regionId": "southwest",
      "adjacencies": [
        "hex-southeast-1",
        "hex-core",
        "hex-west-1",
        "hex-west-3",
        "hex-southwest-2",
        "hex-southwest-3"
      ],
      "shape": "M 498.038 430 L 550 460 L 550 520 L 498.038 550 L 446.077 520 L 446.077 460 Z",
      "position": {
        "x": 498.038,
        "y": 490
      },
      "badgeAnchor": {
        "x": 496.41,
        "y": 488.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southwest-2",
      "name": "Scout",
      "regionId": "southwest",
      "adjacencies": [
        "hex-southwest-3",
        "hex-southwest-1",
        "hex-west-3",
        "hex-west-6",
        "hex-southwest-4",
        "hex-southwest-5"
      ],
      "shape": "M 446.077 520 L 498.038 550 L 498.038 610 L 446.077 640 L 394.115 610 L 394.115 550 Z",
      "position": {
        "x": 446.077,
        "y": 580
      },
      "badgeAnchor": {
        "x": 447.7,
        "y": 578.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southwest-3",
      "name": "Outrider",
      "regionId": "southwest",
      "adjacencies": [
        "hex-southeast-2",
        "hex-southeast-1",
        "hex-southwest-1",
        "hex-southwest-2",
        "hex-southwest-5",
        "hex-southwest-6"
      ],
      "shape": "M 550 520 L 601.962 550 L 601.962 610 L 550 640 L 498.038 610 L 498.038 550 Z",
      "position": {
        "x": 550,
        "y": 580
      },
      "badgeAnchor": {
        "x": 548.38,
        "y": 578.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southwest-4",
      "name": "Skirmisher",
      "regionId": "southwest",
      "adjacencies": [
        "hex-southwest-5",
        "hex-southwest-2",
        "hex-west-6",
        "hex-home-west-3"
      ],
      "shape": "M 394.115 610 L 446.077 640 L 446.077 700 L 394.115 730 L 342.154 700 L 342.154 640 Z",
      "position": {
        "x": 394.115,
        "y": 670
      },
      "badgeAnchor": {
        "x": 392.49,
        "y": 668.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southwest-5",
      "name": "Ambush",
      "regionId": "southwest",
      "adjacencies": [
        "hex-southwest-6",
        "hex-southwest-3",
        "hex-southwest-2",
        "hex-southwest-4"
      ],
      "shape": "M 498.038 610 L 550 640 L 550 700 L 498.038 730 L 446.077 700 L 446.077 640 Z",
      "position": {
        "x": 498.038,
        "y": 670
      },
      "badgeAnchor": {
        "x": 496.41,
        "y": 668.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southwest-6",
      "name": "Charge",
      "regionId": "southwest",
      "adjacencies": [
        "hex-southeast-4",
        "hex-southeast-2",
        "hex-southwest-3",
        "hex-southwest-5"
      ],
      "shape": "M 601.962 610 L 653.923 640 L 653.923 700 L 601.962 730 L 550 700 L 550 640 Z",
      "position": {
        "x": 601.962,
        "y": 670
      },
      "badgeAnchor": {
        "x": 603.59,
        "y": 668.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southeast-1",
      "name": "Marshal",
      "regionId": "southeast",
      "adjacencies": [
        "hex-southeast-3",
        "hex-east-1",
        "hex-core",
        "hex-southwest-1",
        "hex-southwest-3",
        "hex-southeast-2"
      ],
      "shape": "M 601.962 430 L 653.923 460 L 653.923 520 L 601.962 550 L 550 520 L 550 460 Z",
      "position": {
        "x": 601.962,
        "y": 490
      },
      "badgeAnchor": {
        "x": 603.59,
        "y": 488.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southeast-2",
      "name": "General",
      "regionId": "southeast",
      "adjacencies": [
        "hex-southeast-5",
        "hex-southeast-3",
        "hex-southeast-1",
        "hex-southwest-3",
        "hex-southwest-6",
        "hex-southeast-4"
      ],
      "shape": "M 653.923 520 L 705.885 550 L 705.885 610 L 653.923 640 L 601.962 610 L 601.962 550 Z",
      "position": {
        "x": 653.923,
        "y": 580
      },
      "badgeAnchor": {
        "x": 652.3,
        "y": 578.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southeast-3",
      "name": "Captain",
      "regionId": "southeast",
      "adjacencies": [
        "hex-southeast-6",
        "hex-east-2",
        "hex-east-1",
        "hex-southeast-1",
        "hex-southeast-2",
        "hex-southeast-5"
      ],
      "shape": "M 705.885 430 L 757.846 460 L 757.846 520 L 705.885 550 L 653.923 520 L 653.923 460 Z",
      "position": {
        "x": 705.885,
        "y": 490
      },
      "badgeAnchor": {
        "x": 707.51,
        "y": 488.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southeast-4",
      "name": "Colonel",
      "regionId": "southeast",
      "adjacencies": [
        "hex-southeast-5",
        "hex-southeast-2",
        "hex-southwest-6",
        "hex-home-east-3"
      ],
      "shape": "M 705.885 610 L 757.846 640 L 757.846 700 L 705.885 730 L 653.923 700 L 653.923 640 Z",
      "position": {
        "x": 705.885,
        "y": 670
      },
      "badgeAnchor": {
        "x": 707.51,
        "y": 668.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southeast-5",
      "name": "Garrison",
      "regionId": "southeast",
      "adjacencies": [
        "hex-southeast-6",
        "hex-southeast-3",
        "hex-southeast-2",
        "hex-southeast-4"
      ],
      "shape": "M 757.846 520 L 809.808 550 L 809.808 610 L 757.846 640 L 705.885 610 L 705.885 550 Z",
      "position": {
        "x": 757.846,
        "y": 580
      },
      "badgeAnchor": {
        "x": 756.22,
        "y": 578.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-southeast-6",
      "name": "Command",
      "regionId": "southeast",
      "adjacencies": [
        "hex-east-4",
        "hex-east-2",
        "hex-southeast-3",
        "hex-southeast-5"
      ],
      "shape": "M 809.808 430 L 861.769 460 L 861.769 520 L 809.808 550 L 757.846 520 L 757.846 460 Z",
      "position": {
        "x": 809.808,
        "y": 490
      },
      "badgeAnchor": {
        "x": 811.43,
        "y": 488.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-home-west-1",
      "name": "Bunker",
      "regionId": "home-west-1",
      "adjacencies": [
        "hex-northwest-4"
      ],
      "shape": "M 255.884 70 L 307.846 100 L 307.846 160 L 255.884 190 L 203.922 160 L 203.922 100 Z",
      "position": {
        "x": 255.884,
        "y": 130
      },
      "badgeAnchor": {
        "x": 254.26,
        "y": 128.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-home-west-2",
      "name": "Outpost",
      "regionId": "home-west-2",
      "adjacencies": [
        "hex-west-4"
      ],
      "shape": "M 100 340 L 151.962 370 L 151.962 430 L 100 460 L 48.038 430 L 48.038 370 Z",
      "position": {
        "x": 100,
        "y": 400
      },
      "badgeAnchor": {
        "x": 101.62,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-home-west-3",
      "name": "Aegis",
      "regionId": "home-west-3",
      "adjacencies": [
        "hex-southwest-4"
      ],
      "shape": "M 255.884 610 L 307.846 640 L 307.846 700 L 255.884 730 L 203.922 700 L 203.922 640 Z",
      "position": {
        "x": 255.884,
        "y": 670
      },
      "badgeAnchor": {
        "x": 254.26,
        "y": 668.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-home-east-1",
      "name": "Fortress",
      "regionId": "home-east-1",
      "adjacencies": [
        "hex-northeast-4"
      ],
      "shape": "M 844.116 70 L 896.078 100 L 896.078 160 L 844.116 190 L 792.154 160 L 792.154 100 Z",
      "position": {
        "x": 844.116,
        "y": 130
      },
      "badgeAnchor": {
        "x": 842.49,
        "y": 128.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-home-east-2",
      "name": "Anvil",
      "regionId": "home-east-2",
      "adjacencies": [
        "hex-east-4"
      ],
      "shape": "M 1000 340 L 1051.962 370 L 1051.962 430 L 1000 460 L 948.038 430 L 948.038 370 Z",
      "position": {
        "x": 1000,
        "y": 400
      },
      "badgeAnchor": {
        "x": 1001.62,
        "y": 398.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hex-home-east-3",
      "name": "Bulwark",
      "regionId": "home-east-3",
      "adjacencies": [
        "hex-southeast-4"
      ],
      "shape": "M 844.116 610 L 896.078 640 L 896.078 700 L 844.116 730 L 792.154 700 L 792.154 640 Z",
      "position": {
        "x": 844.116,
        "y": 670
      },
      "badgeAnchor": {
        "x": 842.49,
        "y": 668.13
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "ruleOverlay": {
    "sets": [
      {
        "id": "core",
        "label": "The Core",
        "glyph": "hexcore",
        "color": "#ef4444",
        "territories": {
          "ids": [
            "hex-core"
          ]
        }
      }
    ],
    "rules": [
      {
        "id": "core",
        "set": "core",
        "facts": [
          {
            "kind": "defend",
            "die": 4
          },
          {
            "kind": "bonus",
            "value": 8
          }
        ]
      }
    ],
    "chips": []
  },
  "geometryVersion": "v1-b5e6f0ae-62b5a4c7",
  "seaRoutes": [
    {
      "aId": "hex-east-4",
      "bId": "hex-home-east-2",
      "from": {
        "x": 913.731,
        "y": 400
      },
      "to": {
        "x": 948.038,
        "y": 400
      }
    },
    {
      "aId": "hex-northeast-4",
      "bId": "hex-home-east-1",
      "from": {
        "x": 757.846,
        "y": 130
      },
      "to": {
        "x": 792.154,
        "y": 130
      }
    },
    {
      "aId": "hex-northwest-4",
      "bId": "hex-home-west-1",
      "from": {
        "x": 342.154,
        "y": 130
      },
      "to": {
        "x": 307.846,
        "y": 130
      }
    },
    {
      "aId": "hex-west-4",
      "bId": "hex-home-west-2",
      "from": {
        "x": 186.269,
        "y": 400
      },
      "to": {
        "x": 151.962,
        "y": 400
      }
    },
    {
      "aId": "hex-southwest-4",
      "bId": "hex-home-west-3",
      "from": {
        "x": 342.154,
        "y": 670
      },
      "to": {
        "x": 307.846,
        "y": 670
      }
    },
    {
      "aId": "hex-southeast-4",
      "bId": "hex-home-east-3",
      "from": {
        "x": 757.846,
        "y": 670
      },
      "to": {
        "x": 792.154,
        "y": 670
      }
    }
  ],
  "borderChevronMarks": [
    {
      "x": 575.98,
      "y": 355,
      "angle": 120
    },
    {
      "x": 601.96,
      "y": 400,
      "angle": 180
    },
    {
      "x": 575.98,
      "y": 445,
      "angle": -120
    },
    {
      "x": 524.02,
      "y": 445,
      "angle": -60
    },
    {
      "x": 498.04,
      "y": 400,
      "angle": 0
    },
    {
      "x": 524.02,
      "y": 355,
      "angle": 60
    }
  ]
}
